// extracted by mini-css-extract-plugin
export default {"searchInputWrapper":"search-input_searchInputWrapper__P6rMp","searchIconLeft":"search-input_searchIconLeft__kHtKs","searchInput":"search-input_searchInput__1HfKh"};